<template>
  <div class="body">
    <div class="container">
      <img :src="this.image" class="img" />
      <div class="details">
        <div class="title">{{ title }}</div>
        <div class="noteDetails">
          <div class="noteStar" v-if="rating > 0" @click="goNote">
            <span v-for="n in 5" :key="n">
              <img v-if="rating >= n" class="star" alt="full star" src="../../assets/etoile.png" />
              <img v-else class="star-empty" alt="full star" src="../../assets/etoile vide.png" />
            </span>
          </div>
          <div v-else class="noteText" id="test" @click="goNote">{{ $t('tasting.rate') }}</div>
          <div class="taste" @click="$emit('click')">{{ $t('tasting.taste') }}</div>
          <!-- OVERHERE -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import unrated from '@/assets/rate_empty.png'
import rated from '@/assets/rate_full.png'
import degusted from '@/assets/wine_full.png'
import undegusted from '@/assets/wine_empty.png'

export default {
  name: 'VvDesktopTasteTile',
  props: {
    title: {
      type: String,
      required: true
    },
    ratingPath: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: false
    },
    status: {
      type: Object,
      required: false
    },
    bottleId: {
      type: String,
      required: false
    },
    rating: {
      type: Number,
      required: false
    }
  },
  computed: {
    iconRate() {
      if (this.status && 'rating' in this.status) return rated
      else if (!this.status) return unrated
      else return unrated
    },

    iconWine() {
      if (this.status && this.status['complete']) return degusted
      else if (!this.status) return undegusted
      else return undegusted
    },
    isDesktop() {
      return ['mobile', 'tablet'].includes(this.$mq) ? false : true
    }
  },
  methods: {
    go() {
      if (this.$route.path.includes('/theme/')) {
        localStorage.setItem('comingFromTasteThemeId', this.$route.params.themeId)
      }
      this.$router.push({ name: 'tasting-rating', params: { tastingId: this.ratingPath } })
    },
    goNote() {
      if (this.$route.path.includes('/theme/')) {
        localStorage.setItem('comingFromTasteThemeId', this.$route.params.themeId)
      }
      this.$router.push({ name: 'tasting-rating', params: { tastingId: this.ratingPath } })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.noteText {
  font: normal normal bold 22px Helvetica;
  color: #ffff;
  background-color: $primary;
  border-radius: 10px;
  width: 110px;
  height: 27px;
  text-transform: lowercase;
  padding: 5px 12px;
  cursor: pointer;
  font-weight: 700;
  display: inline-block;
  text-align: center;
}
.noteText::first-letter {
  text-transform: uppercase;
}
.star {
  display: block;
  margin: auto;
  width: 27px;
  height: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}
.star-empty {
  display: block;
  margin: auto;
  width: 27px;
  height: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}
.taste {
  font: normal normal bold 22px Helvetica;
  width: 170px;
  height: 27px;
  text-transform: lowercase;
  color: #ffff;
  background-color: $primary;
  border-radius: 10px;
  margin-top: 5px;
  padding: 5px 10px;
  cursor: pointer;
  font-weight: 700;
  display: inline-block;
  text-align: center;
}
.taste::first-letter {
  text-transform: uppercase;
}
.noteDetails {
  display: flex;
  flex-direction: column;
  margin-bottom: -20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.note {
  background-color: $primary;
  border-radius: 30px;
  width: 60%;
  display: flex;
  flex-direction: row;
  padding: 5px;
  cursor: pointer;
}
.noteStar {
  display: flex;
  flex-direction: row;
  padding: 5px;
  max-width: 200px;
}
.title {
  font: normal normal bold 23px/30px Helvetica;
  letter-spacing: 0.66px;
  color: #1d1b1b;
  text-align: center;
}
.details {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
  align-items: center;
  width: 70%;
}
.container {
  display: flex;
  flex-direction: row;
}
.img {
  object-fit: cover;
  height: 230px;
}
.body {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
</style>
